﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';


@Component({
	selector: 'app-tata-common-login',
	templateUrl: './tata-common-login.component.html',
	styleUrls: ['./tata-common-login.component.css']
})
export class TataCommonLoginComponent implements OnInit {

	form: FormGroup;
	public role: any;
	public entityType: any;
	showModify: boolean = false
	tataID: any
	hide: boolean = true;
	public readonly: boolean = false;
	homeRole: boolean = false;
	errorUser: boolean = false;
	errorReg: boolean = false;
	EntityId: any;
	Ttsl_EmailID: any;
	commonLoginForm: FormGroup;
	submitted: boolean = false;
	public loginFlag = false;
	constructor(private formBuilder: FormBuilder,
		private router: Router,
		private db: $DBManagerService,
		private ls: APILoginService,
		private _route: ActivatedRoute,
		private $modal: $ModalManagerService,
		private evt: $BroadcastManagerService) {
		this._route.params.subscribe((params) => {
		})
	}

	ngOnInit() {
		this.commonLoginForm = this.formBuilder.group({
			Ttsl_ID: ['', [Validators.required]],
			password: ['', [Validators.required]],
			//password: ['', [Validators.required]],
		});
		this.db.clearDB();
		//this.evt.emit({ 'click': 'HEADER_EVENT' });
		//this.evt.emit({ 'click': 'HEADER_EVENT_' }); 
	}

	get f() {
		return this.commonLoginForm.controls;
	}

	onSubmit() {
		this.submitted = true;
		if (this.commonLoginForm.invalid) {
			console.log("invalid form: ", this.commonLoginForm);
			return;
		}
		else {
			this.entityType = "Tata Employee";
			var data2 = {
				"Ttsl_ID": this.f.Ttsl_ID.value,
				"Ttsl_Password": this.f.password.value
			};
			console.log("data2;  ", data2)
			console.log("data2.Ttsl_ID;  ", data2.Ttsl_ID)
			console.log("this.f.Ttsl_ID.value;  ", this.f.Ttsl_ID.value)
			this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.entityType);
			this.db.set(Constants.SESSSION_STORAGE, Constants.TTSL_ID, this.f.Ttsl_ID.value);
			this.loginAPI(data2);
		}
	}

	//Check username, Pwd from mongo
	loginAPI(data) {
		this.ls.tatalogin(data)
			.subscribe((r) => {
				console.log("tatalogin", r)
				if (r.message == "Ttsl user ID Not present") {
					this.errorReg = true;
					this.errorUser = true;
					this.$modal.errorModal({
						title: 'Login',
						msg: 'Ttsl is not registered'
					});
				}
				else if (r.message == "login failed") {
					this.errorReg = true;
					this.errorUser = true;
					this.$modal.errorModal({
						title: 'Login',
						msg: 'login failed'
					});
				}
				else if (r.message == "login success") {
					this.evt.emit({ 'click': 'HEADER_EVENT' });
					this.evt.emit({ 'click': 'HEADER_EVENT_' });
					this.readonly = true;


					this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
					this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.ttslUserObj.Ttsl_ID);
					this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME, r.ttslUserObj.Ttsl_MobileNo);
					this.db.set(Constants.SESSSION_STORAGE, Constants.Entity_EmailID, r.ttslUserObj.Ttsl_EmailID);

					if (r.ttslUserObj.Ttsl_RoleCategory == "Process Owner")
						this.db.set(Constants.SESSSION_STORAGE, Constants.Ttsl_ProcessRole, JSON.stringify(r.ttslUserObj.Ttsl_ProcessRole));
					else
						this.db.set(Constants.SESSSION_STORAGE, Constants.Ttsl_ProcessRole, JSON.stringify(r.ttslUserObj.Registrar_Status));

					var TataEmpRoles = [];
					try {
						if (r.ttslUserObj.Registrar_Status != null && r.ttslUserObj.Registrar_Status != '') {
							TataEmpRoles = Object.keys(r.ttslUserObj.Registrar_Status).filter(key => r.ttslUserObj.Registrar_Status[key] == "A");
						}
						else if (r.ttslUserObj.Ttsl_ProcessRole != null && r.ttslUserObj.Ttsl_ProcessRole != '') {
							TataEmpRoles = Object.keys(r.ttslUserObj.Ttsl_ProcessRole).filter(key => r.ttslUserObj.Ttsl_ProcessRole[key] == "A");
						}

					}
					catch (err) {
						console.log("NO registrar roles")
					}
					if (r.ttslUserObj.oldRolesArray){
					console.log("r.ttslUserObj.oldRolesArray", r.ttslUserObj.oldRolesArray)
					console.log("TataEmpRoles", TataEmpRoles)

					TataEmpRoles=TataEmpRoles.concat(r.ttslUserObj.oldRolesArray)
					console.log("r.ttslUserObj.oldRolesArray", r.ttslUserObj.oldRolesArray)
					console.log("TataEmpRoles", TataEmpRoles)
					}
					this.db.set(Constants.SESSSION_STORAGE, Constants.TATAEMPROLES, TataEmpRoles);

					this.EntityId = r.ttslUserObj.Ttsl_ID;
					this.Ttsl_EmailID = r.ttslUserObj.Ttsl_EmailID;
					this.errorReg = false;
					this.errorUser = false;
					this.loginFlag = true;
					this.homeRole = true;
					this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
					this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
					this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME, r.ttslUserObj.Ttsl_UserName);
					localStorage.setItem('currentUser', "TATA");
					if (TataEmpRoles.includes("501"))
						this.router.navigateByUrl('/set-preference');
					else if (TataEmpRoles.includes("302"))
						this.router.navigateByUrl('/entity-worklist');
					else if (TataEmpRoles.includes("303"))
						//this.router.navigateByUrl('/principal-header-summary');
						this.router.navigateByUrl('/header-registerworklist');
					else if (TataEmpRoles.includes("304"))
						this.router.navigateByUrl('/template-worklist');
					else if (TataEmpRoles.includes("305"))
						this.router.navigateByUrl('/consent-template-registrar-worklist');
					else if (TataEmpRoles.includes("306"))
						this.router.navigateByUrl('/complaint-registration-ttl-agent');
					else if (TataEmpRoles.includes("307"))
						this.router.navigateByUrl('/');
					else if (TataEmpRoles.includes("308"))
						this.router.navigateByUrl('/');
					else if (TataEmpRoles.includes("309"))
						this.router.navigateByUrl('/');
					else if (TataEmpRoles.includes("310"))
						this.router.navigateByUrl('/');
					else if (TataEmpRoles.includes("311"))
						this.router.navigateByUrl('/complaint-handling-reverse-violation');
					else if (TataEmpRoles.includes("601"))
						this.router.navigateByUrl('/import-preference');

					else if (TataEmpRoles.includes("100"))
						this.router.navigateByUrl('/import-preference');
					else
						this.router.navigateByUrl('/ttlusers-summary');
				}
				else if (r.message == "Ttsl user is pending for approval") {
					this.tataID = this.db.get(Constants.SESSSION_STORAGE, Constants.TTSL_ID)
					this.errorReg = true;
					this.errorUser = false;
					this.showModify = true
					this.$modal.errorModal({
						title: 'Login',
						msg: 'Ttsl user is pending for approval'
					});
				}
				else if (r.message == "Ttsl user is rejected") {
					this.errorReg = true;
					this.errorUser = false;
					this.$modal.errorModal({
						title: 'Login',
						msg: 'Ttsl user is rejected'
					});
				}
				else if (r.message == "login fail") {
					this.errorReg = true;
					this.errorUser = false;
					this.$modal.errorModal({
						title: 'Login',
						msg: 'login fail, User may not exists'
					});
				}
				else {
					this.errorUser = true;
					this.errorReg = false;
				}
			});
	}
}

